import { Users, TrendingUp } from "lucide-react";
import { SectionHeading } from "@/components/common/SectionHeading";
import { Reveal } from "@/components/common/Reveal";

const LEVELS = [
  { id: "explorer", name: "Explorer", focus: "Curiosity, observation and trying things out", color: "bg-mint" },
  { id: "inquirer", name: "Inquirer", focus: "Asking questions, investigating and understanding", color: "bg-sky" },
  { id: "practitioner", name: "Practitioner", focus: "Applying knowledge and solving problems", color: "bg-lemon" },
  { id: "innovator", name: "Innovator", focus: "Critical thinking, creating and improving", color: "bg-lavender" },
  { id: "self-directed", name: "Self-Directed Learner", focus: "Planning, monitoring, reflecting and transferring learning independently", color: "bg-blush" },
];

const MixedAge = () => (
  <div className="card-soft flex items-start gap-4 p-7 sm:p-8" data-testid="mixed-age">
    <span className="grid h-12 w-12 shrink-0 place-items-center rounded-2xl bg-mint"><Users className="h-6 w-6" aria-hidden="true" /></span>
    <div>
      <h3 className="text-2xl font-semibold">Mixed-age classes</h3>
      <p className="mt-2 text-ink-soft">Students learn in mixed-age classes, where younger and older learners explore, collaborate and grow together.</p>
    </div>
  </div>
);

const GrowthLevels = () => (
  <div className="card-soft p-7 sm:p-9" data-testid="competency-levels">
    <h3 className="flex items-center gap-2 text-2xl font-semibold"><TrendingUp className="h-6 w-6" aria-hidden="true" /> MUCCI Five-Level Learner Growth Framework</h3>
    <p className="mt-2 text-ink-soft">Describes how a learner grows, whatever their age.</p>
    <ol className="mt-8 grid grid-cols-1 items-end gap-3 sm:grid-cols-2 lg:grid-cols-5">
      {LEVELS.map((l, i) => (
        <li key={l.id} className={`flex flex-col justify-end rounded-2xl ${l.color} p-5 lg:min-h-[var(--step-h)]`} style={{ "--step-h": `${130 + i * 40}px` }}
          data-testid={`level-${l.id}`}>
          <span className="text-xs font-bold text-ink-soft">Level {i + 1}</span>
          <span className="font-heading text-lg font-semibold leading-tight">{l.name}</span>
          <span className="mt-1 text-sm leading-snug">{l.focus}</span>
        </li>
      ))}
    </ol>
  </div>
);

export const ProgressionSection = () => (
  <section className="section-y" aria-labelledby="progression-title" data-testid="progression-section">
    <div className="container-x">
      <SectionHeading id="progression-title" eyebrow="Personalised learning" title="Personalised learning progression"
        intro="Age and mastery are two different things. Students learn together in mixed-age classes, and we track each learner's growth through five levels." />
      <div className="mt-12 space-y-6">
        <Reveal><MixedAge /></Reveal>
        <Reveal delay={0.1}><GrowthLevels /></Reveal>
      </div>
    </div>
  </section>
);
